import Reveal from "@/components/base/Reveal";
import { timelineItems } from "@/mocks/siteContent";

const toneMap: Record<string, { dot: string; badge: string }> = {
  primary: { dot: "bg-primary-500", badge: "bg-primary-100 text-primary-700" },
  accent: { dot: "bg-accent-500", badge: "bg-accent-100 text-accent-700" },
  secondary: { dot: "bg-secondary-500", badge: "bg-secondary-100 text-secondary-900" },
};

export default function TimelineSection() {
  return (
    <section id="timeline" className="scroll-mt-20 w-full bg-background-100">
      <div className="w-full px-4 md:px-8 lg:px-12 py-14 md:py-20">
        <Reveal>
          <div className="flex items-center gap-3 mb-3">
            <span className="h-px w-8 bg-accent-500"></span>
            <span className="font-label text-xs md:text-sm tracking-widest text-accent-700 uppercase">
              Timeline
            </span>
          </div>
          <h2 className="font-heading font-bold text-foreground-950 text-2xl md:text-4xl">
            最新动态追踪时间线
          </h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base max-w-3xl leading-relaxed">
            按时间先后整理近期围绕夏目彩春的网络讨论与话题变化。以下为话题整理，并非官方发布，仅供了解讨论走向。
          </p>
        </Reveal>

        <div className="mt-10 grid grid-cols-1 lg:grid-cols-12 gap-8">
          <div className="lg:col-span-8">
            <div className="relative pl-6 md:pl-8">
              <span className="absolute left-[7px] md:left-[9px] top-2 bottom-2 w-px bg-background-300"></span>
              <div className="space-y-4">
                {timelineItems.map((item, i) => {
                  const tone = toneMap[item.tone] ?? toneMap.primary;
                  return (
                    <Reveal key={item.date} delay={i * 60}>
                      <div className="relative">
                        <span
                          className={`absolute -left-6 md:-left-8 top-5 w-3.5 h-3.5 rounded-full ring-4 ring-background-100 ${tone.dot}`}
                        ></span>
                        <div className="rounded-xl border border-background-200 bg-background-50 p-4 md:p-5">
                          <div className="flex flex-wrap items-center gap-2 mb-2">
                            <span className="font-heading font-bold text-foreground-950 text-sm md:text-base">
                              {item.date}
                            </span>
                            <span
                              className={`text-[11px] px-2 py-0.5 rounded-full font-label ${tone.badge}`}
                            >
                              {item.tag}
                            </span>
                          </div>
                          <h3 className="text-sm md:text-base font-semibold text-foreground-900">
                            {item.title}
                          </h3>
                          <p className="mt-1.5 text-xs md:text-sm text-foreground-600 leading-relaxed">
                            {item.desc}
                          </p>
                        </div>
                      </div>
                    </Reveal>
                  );
                })}
              </div>
            </div>
          </div>

          <Reveal className="lg:col-span-4" delay={120}>
            <div className="w-full h-[220px] md:h-[260px] rounded-2xl overflow-hidden border border-background-200 bg-background-50">
              <img
                src="https://readdy.ai/api/search-image?query=Abstract%20warm%20gradient%20of%20rose%20pink%2C%20peach%20and%20soft%20gold%20flowing%20waves%2C%20elegant%20minimal%20texture%2C%20dreamy%20soft%20light%2C%20artistic%20background%2C%20beautiful%20harmonious%20composition&width=1200&height=600&seq=natsume-timeline-03&orientation=landscape"
                alt="动态时间线配图，暖色抽象渐变"
                title="夏目彩春 最新动态时间线"
                className="w-full h-full object-cover object-top"
              />
            </div>

            <div className="mt-5 rounded-2xl border border-background-200 bg-background-50 p-5">
              <h3 className="text-sm font-semibold text-foreground-950 flex items-center gap-2">
                <i className="ri-lightbulb-flash-line text-accent-600"></i>
                看动态的小建议
              </h3>
              <ul className="mt-3 space-y-2.5">
                <li className="flex items-start gap-2 text-xs md:text-sm text-foreground-600 leading-relaxed">
                  <i className="ri-arrow-right-s-line text-primary-500 mt-0.5"></i>
                  <span>热度涨得快的话题，往往来源参差，先看有没有原始出处。</span>
                </li>
                <li className="flex items-start gap-2 text-xs md:text-sm text-foreground-600 leading-relaxed">
                  <i className="ri-arrow-right-s-line text-primary-500 mt-0.5"></i>
                  <span>同一件事多平台说法不一，说明还在传播早期，别急着下结论。</span>
                </li>
                <li className="flex items-start gap-2 text-xs md:text-sm text-foreground-600 leading-relaxed">
                  <i className="ri-arrow-right-s-line text-primary-500 mt-0.5"></i>
                  <span>旧内容被翻出容易当成新动态，留意发布时间能少踩坑。</span>
                </li>
              </ul>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}